import { Directive } from '@angular/core';

@Directive({ selector: '[adEl]', standalone: true })
export class AdElDirective {}
